import React, { useState } from 'react';

const SuggestionList = ({ options, searchTerm, selectedPopularSearch, clickEvent }) => {

    const [state, setState] = useState({
        localSearchTem: ''
    });

    if ("" == searchTerm) {
        return null;
    }
    if (selectedPopularSearch) {
        return null;
    }
    if (searchTerm == state.localSearchTem) {
        return null;
    }

    const suggestionsList = options.filter(e => e.display_name.toLowerCase().startsWith(searchTerm.toLowerCase(), 0));

    //If No suggestions found return null.
    if (Array.isArray(suggestionsList) && suggestionsList.length === 0) {
        return null;
    }

    const handleClick = (value) => {
        setState({ localSearchTem: value.display_name });
        clickEvent(value);
    }


    return (

        <div className="suggestion-list-wrap">
            <ul className="suggestion-list-items-wrap">
                {suggestionsList.map((item, index) => {
                    let content = item.display_name
                    searchTerm.split(" ").forEach(function (item) {
                        content = content.replace(new RegExp('(' + item + ')', 'gi'), '<span class="search-highlight">$1</span>');
                    });

                    return (
                        <li key={index} className="suggestion-list-items" onClick={() => handleClick(item)}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: content
                                }} />
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
export default SuggestionList